import * as React from 'react';
import { Button } from 'reactstrap';

import './ConfigurationDelete.page.scss';
import { RequestApiResult, requestAPIActions, RequestApiHttpPayload } from 'loopback-react-request';
import { ConfigurationModel } from 'franke-trough-dependencies';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { Redirect } from 'react-router';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ConfigurationDelete.messages';
import { isConfigurationEditable } from 'src/redux/utils.redux';

export interface ConfigurationDeleteProps {
  dispatch: any;
  configuration: RequestApiResult<ConfigurationModel & {deleted: boolean}>;
  configurationId: string;
  authenticator: GlobalPrivateState['authenticator'];
  userData: GlobalPrivateState['userData'];
}

export interface ConfigurationDeleteState {
  redirect: boolean;
}

export class ConfigurationDeletePartial extends React.Component<ConfigurationDeleteProps, ConfigurationDeleteState> {
  constructor(props: ConfigurationDeleteProps) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      redirect: false,
    };
  }

  componentDidUpdate (prevProps: ConfigurationDeleteProps) {
    const configuration = this.configuration;
    const prevConfiguration = prevProps.configuration.result;
    const userData = this.userData;
    const prevUserData = prevProps.userData.result;

    if ((configuration && configuration.updated_at) !== (prevConfiguration && prevConfiguration.updated_at)) {
      if (!this.state.redirect && configuration && configuration.deleted) {
        // Configuration is deleted
        this.setState({
          redirect: true,
        });
        this.props.dispatch(requestAPIActions.load<RequestApiHttpPayload>(
          'groups', {
            url: `/Groups/my-groups`
          },
          true
        ));
      }
    }

    if ((userData && userData.updated_at) !== (prevUserData && prevUserData.updated_at)) {
      if (!this.state.redirect && configuration && userData && userData.deletedConfigurations && userData.deletedConfigurations.includes(configuration.id)) {
        // Configuration is deleted
        this.setState({
          redirect: true,
        });
        this.props.dispatch(requestAPIActions.load<RequestApiHttpPayload>(
          'groups', {
            url: `/Groups/my-groups`
          },
          true
        ));
      }
    }
  }

  public render() {
    return (
      <div className="page-configuration-delete d-flex justify-content-center align-items-center vh-100">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h3 className="mb-5">
                <FormattedMessage {...MESSAGES.configurationDeleteHeadline} />
              </h3>
              <Button
                className="btn"
                onClick={this.handleClick}
                disabled={!isConfigurationEditable()}
              >
                <FormattedMessage {...MESSAGES.configurationDeleteButton} />
              </Button>
            </div>
          </div>
        </div>
        {this.state.redirect && (
          <Redirect to={`/`} />
        )}
      </div>
    );
  }

  private get configuration(): ConfigurationModel & {deleted: boolean} | undefined {
    return this.props.configuration && this.props.configuration.result as ConfigurationModel & {deleted: boolean};
  }

  private get userData() {
    return this.props.userData && this.props.userData.result;
  }

  private dispatchRemove() {
    const { authenticator } = this.props;

    if (!this.configuration || !this.userData || !authenticator.accessToken) {
      return;
    }

    const userId = authenticator.accessToken.userId.toString();

    if (this.configuration.userId !== userId) {
      const data = this.userData;
      data.deletedConfigurations = data.deletedConfigurations && [...data.deletedConfigurations, this.configuration.id] || [this.configuration.id];
    
      this.props.dispatch(requestAPIActions.load(
        'userData', {
          url: `/UserData/${this.userData.id}`,
          options: {
            method: 'PATCH',
            data,
          },
        },
        true,
      ));
    } else {
      const data: ConfigurationModel & {deleted: boolean} = this.configuration;
      data.deleted = true;

      this.props.dispatch(requestAPIActions.load(
        'configuration', {
          url: `/Configurations/${this.configuration.id}`,
          options: {
            method: 'PATCH',
            data,
          },
        },
        true,
      ));
    }
  }

  private handleClick(event: React.SyntheticEvent<HTMLButtonElement>) {
    this.dispatchRemove();
  }
}

export const ConfigurationDelete = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  authenticator: state.authenticator,
  userData: state.userData,
}))(ConfigurationDeletePartial);

export default ConfigurationDelete;
